import React from 'react'
import { Link } from 'react-router-dom'

const PricingInner = () => {
    return (
        <div className="pricing-area-2 space">
            <div className="container">
                <div className="row gy-4 justify-content-center">
                    <div className="col-xl-4 col-md-6">
                        <div className="pricing-card">
                            <div className="pricing-card-price-wrap">
                                <h3 className="pricing-card_price">
                                    <span className="currency">$</span>32
                                    <span className="duration">/month</span>
                                </h3>
                            </div>
                            <div className="pricing-card-icon-wrap">
                                <h4 className="pricing-card_title">Consult</h4>
                                <div className="pricing-card_icon">
                                    <img src="assets/img/icon/picing-icon_2-1.svg" alt="img" />
                                </div>
                            </div>
                            <div className="pricing-card-details">
                                <div className="checklist">
                                    <ul>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Mistakes To Avoid
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Your Startup
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Knew About Fonts
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Winning Metric for Your Startup
                                        </li>
                                    </ul>
                                </div>
                                <Link className="global-btn" to="/contact">
                                    Get Now <img src="assets/img/icon/right-icon2.svg" alt="Gohub" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="pricing-card">
                            <div className="pricing-card-price-wrap">
                                <h3 className="pricing-card_price">
                                    <span className="currency">$</span>25
                                    <span className="duration">/month</span>
                                </h3>
                            </div>
                            <div className="pricing-card-icon-wrap">
                                <h4 className="pricing-card_title">Basic</h4>
                                <div className="pricing-card_icon">
                                    <img src="assets/img/icon/picing-icon_2-2.svg" alt="img" />
                                </div>
                            </div>
                            <div className="pricing-card-details">
                                <div className="checklist">
                                    <ul>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Mistakes To Avoid
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Your Startup
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Knew About Fonts
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Winning Metric for Your Startup
                                        </li>
                                    </ul>
                                </div>
                                <Link className="global-btn" to="/contact">
                                    Get Now <img src="assets/img/icon/right-icon2.svg" alt="Gohub" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="pricing-card">
                            <div className="pricing-card-price-wrap">
                                <h3 className="pricing-card_price">
                                    <span className="currency">$</span>36
                                    <span className="duration">/month</span>
                                </h3>
                            </div>
                            <div className="pricing-card-icon-wrap">
                                <h4 className="pricing-card_title">Pro</h4>
                                <div className="pricing-card_icon">
                                    <img src="assets/img/icon/picing-icon_2-3.svg" alt="img" />
                                </div>
                            </div>
                            <div className="pricing-card-details">
                                <div className="checklist">
                                    <ul>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Mistakes To Avoid
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Your Startup
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Knew About Fonts
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Winning Metric for Your Startup
                                        </li>
                                    </ul>
                                </div>
                                <Link className="global-btn" to="/contact">
                                    Get Now <img src="assets/img/icon/right-icon2.svg" alt="Gohub" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="pricing-card">
                            <div className="pricing-card-price-wrap">
                                <h3 className="pricing-card_price">
                                    <span className="currency">$</span>12
                                    <span className="duration">/month</span>
                                </h3>
                            </div>
                            <div className="pricing-card-icon-wrap">
                                <h4 className="pricing-card_title">Beginer</h4>
                                <div className="pricing-card_icon">
                                    <img src="assets/img/icon/picing-icon_2-4.svg" alt="img" />
                                </div>
                            </div>
                            <div className="pricing-card-details">
                                <div className="checklist">
                                    <ul>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Mistakes To Avoid
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Your Startup
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Knew About Fonts
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Winning Metric for Your Startup
                                        </li>
                                    </ul>
                                </div>
                                <Link className="global-btn" to="/contact">
                                    Get Now <img src="assets/img/icon/right-icon2.svg" alt="Gohub" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="pricing-card">
                            <div className="pricing-card-price-wrap">
                                <h3 className="pricing-card_price">
                                    <span className="currency">$</span>35
                                    <span className="duration">/month</span>
                                </h3>
                            </div>
                            <div className="pricing-card-icon-wrap">
                                <h4 className="pricing-card_title">Investor</h4>
                                <div className="pricing-card_icon">
                                    <img src="assets/img/icon/picing-icon_2-5.svg" alt="img" />
                                </div>
                            </div>
                            <div className="pricing-card-details">
                                <div className="checklist">
                                    <ul>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Mistakes To Avoid
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Your Startup
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Knew About Fonts
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Winning Metric for Your Startup
                                        </li>
                                    </ul>
                                </div>
                                <Link className="global-btn" to="/contact">
                                    Get Now <img src="assets/img/icon/right-icon2.svg" alt="Gohub" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-md-6">
                        <div className="pricing-card">
                            <div className="pricing-card-price-wrap">
                                <h3 className="pricing-card_price">
                                    <span className="currency">$</span>26
                                    <span className="duration">/month</span>
                                </h3>
                            </div>
                            <div className="pricing-card-icon-wrap">
                                <h4 className="pricing-card_title">Premium</h4>
                                <div className="pricing-card_icon">
                                    <img src="assets/img/icon/picing-icon_2-6.svg" alt="img" />
                                </div>
                            </div>
                            <div className="pricing-card-details">
                                <div className="checklist">
                                    <ul>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Mistakes To Avoid
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Your Startup
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Knew About Fonts
                                        </li>
                                        <li>
                                            <i className="fas fa-angle-double-right" />
                                            Winning Metric for Your Startup
                                        </li>
                                    </ul>
                                </div>
                                <Link className="global-btn" to="/contact">
                                    Get Now <img src="assets/img/icon/right-icon2.svg" alt="Gohub" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default PricingInner